import React from 'react';
import type { Row } from '@tanstack/react-table';

import IconButton from 'components/partials/button/icon-button';

import Icons from 'assets/icons';

interface ExpanderCellProps {
  row: Row<unknown>;
}

const ExpanderCell = ({ row }: ExpanderCellProps): React.JSX.Element | null => {
  if (!row.getCanExpand()) {
    return null;
  }

  const isExpanded = row.getIsExpanded();

  return (
    <IconButton
      variant="reserve-text"
      size="xs"
      icon={
        <span
          className={`inline-flex transition-transform duration-200 ${
            isExpanded ? 'rotate-90' : ''
          }`}
        >
          <Icons.ChevronRight />
        </span>
      }
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        row.toggleExpanded();
      }}
      className="text-gray-700 hover:!bg-gray-100 hover:!text-gray-700 focus-visible:!ring-navy-300"
      aria-label={isExpanded ? 'Collapse row' : 'Expand row'}
      aria-expanded={isExpanded}
      data-testid="expander-button"
    />
  );
};

export default ExpanderCell;
